/* MT/26 guard: when an app renders two or more swatch blocks on the product page, the theme keeps
   swapping them forever (each one wants to sit directly above the size picker). Grouping them in
   one container stops that loop and keeps them above the picker. */
(function () {
  'use strict';
  function start() {
    var buy = document.querySelector('.mt-pdp__buy'), picker = buy && buy.querySelector('.mt-vp');
    if (!picker) return;
    function group() {
      var tops = [];
      buy.querySelectorAll('a[href*="/products/"], a[href^="javascript"]').forEach(function (a) {
        var t = a;
        while (t.parentElement && t.parentElement !== buy && !t.parentElement.matches('.mt-pdp__buy-block, form')) t = t.parentElement;
        var c = typeof t.className === 'string' ? t.className : '';
        if (tops.indexOf(t) !== -1 || /(^|\s)mt-/.test(c) || t.matches('form, .mt-pdp__buy-block')) return;
        if (!/pl-|swatch|color/i.test(c + ' ' + (t.id || '') + ' ' + t.textContent.slice(0, 40))) return;
        tops.push(t);
      });
      if (tops.length < 2) return;
      var w = buy.querySelector('.mt-swatch-group');
      if (!w) {
        w = document.createElement('div');
        w.className = 'mt-swatch-group';
        picker.parentNode.insertBefore(w, picker);
      }
      tops.forEach(function (t) { w.appendChild(t); });
    }
    group();
    new MutationObserver(group).observe(buy, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();